// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__dee2a","dotsWrapper":"styles_dotsWrapper__sKPvg","dot":"styles_dot__4aEZn","dotWave":"styles_dotWave__E6vN2","message":"styles_message__Uevab"};